import { FC, Fragment } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "utils/hooks/storeHooks";
import { selectIsAuth } from "store/session/selectors";

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: FC<PrivateRouteProps> = ({
  children,
}: PrivateRouteProps) => {
  const isAuthenticated = useAppSelector(selectIsAuth);
  return (
    <Fragment>
      {isAuthenticated ? children : <Navigate to="/login" replace />}
    </Fragment>
  );
};

export default PrivateRoute;
